import React from 'react'
import BadgePill from '../sections/ProductListing/BadgePill';



interface props {
  filters: any
  setfiltersData: any
  setCatCahnge: any
  dependentFilters: any
  setdependentFilters: any
  clearDependentFilters: any
  priceRange: any
  filtersData: any
  setPriceRange: any
  specs?: boolean
}

function FilterPills({ filters, setfiltersData, setCatCahnge, dependentFilters, setdependentFilters, clearDependentFilters, priceRange, filtersData, setPriceRange, specs }: any) {


  const handleCheckboxChange = (val: any, id: any) => {
    setCatCahnge(true);
    setfiltersData((prev: { [x: string]: any; }) => {
      const updated = prev[val]?.values?.map((item: any, i: any) => {
        if (i === id && prev[val].inputType === "checkbox") {
          return { ...item, isChecked: false };
        } else if (prev[val].inputType === "radio") {
          if (i === id) {
            return { ...item, isChecked: false };
          } else {
            return { ...item, isChecked: false };
          }
        }
        return item;
      });
      return { ...prev, [val]: { ...prev[val], values: updated } };
    });
    clearDependentFilters()
  };

  const handleChangeDependentFilter = (val: any, id: any) => {
    setCatCahnge(true);
    setdependentFilters((prev: { [x: string]: any; }) => {
      const updated = prev[val]?.values?.map((item: any, i: any) => {
        if (i === id && prev[val].inputType === "checkbox") {
          return { ...item, isChecked: false };
        } else if (prev[val].inputType === "radio") {
          if (i === id) {
            return { ...item, isChecked: false };
          } else {
            return { ...item, isChecked: false };
          }
        }
        return item;
      });
      return { ...prev, [val]: { ...prev[val], values: updated } };
    });
  };
  function toTitleCase(str: string) {
    return str.replace(/\w\S*/g, (text: string) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase());
  }

  return (

    <div>
      <div className="mb-3 d-flex gap-2 flex-wrap py-3 ">
        {filters?.filterIndDpendentFilters
          ? Object.keys(filters?.filterIndDpendentFilters).map((val: any, i: any) => (
            <React.Fragment key={i}>
              {filtersData[val]?.values.map(
                (item: any, index: any) =>
                  item.isChecked === true && (
                    <BadgePill clearFilter={() => handleCheckboxChange(val, index)} FilterName={toTitleCase(val?.replaceAll(/^is_/g, "").replace(/_/g, " ").replace(/id/g, " "))} FilterValue={item?.label === 0 ? "No" : item?.label === 1 ? "Yes" : item?.label?.toString()?.replaceAll(/_/g, " ")} />
                  )
              )}
            </React.Fragment>
          ))
          : null}
        {(specs || filters?.filterIndDpendentFilters) && filters.filterDpendentFilters !== undefined
          ? Object.keys(filters.filterDpendentFilters).map((val: any, i: any) => (
            <React.Fragment key={i}>
              {dependentFilters[val]?.values.map(
                (item: any, index: any) =>
                  item.isChecked === true && (
                    <BadgePill
                      clearFilter={() => handleChangeDependentFilter(val, index)}
                      FilterName={toTitleCase(specs ? dependentFilters[val]?.label?.replaceAll(/^is_/g, "").replace(/_/g, " ").replace(/id/g, " ") : val?.replaceAll(/^is_/g, "").replace(/_/g, " ").replace(/id/g, " "))}
                      FilterValue={item?.label === 0 ? "No" : item?.label === 1 ? "Yes" : item?.label?.toString()?.replaceAll(/_/g, " ")}
                    />
                  )
              )}
            </React.Fragment>
          ))
          : ""}
        {priceRange?.to ? <BadgePill clearFilter={() => setPriceRange()} FilterName="Price Range" FilterValue={`PKR ${priceRange.from}-${priceRange.to}`} /> : ""}
      </div>
    </div>
  )
}

export default FilterPills